import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.2/js/sparta-events-utility";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.0.3/js/sparta-store-utility";
import spartaGlobalFunctions from "utilities/global/sparta-global-functions-utility/2.1.1/js/sparta-global-functions-utility";
import _ from "utilities/vendor/lodash/4.13.1/js/lodash.custom.min";
import Handlebars from "utilities/vendor/handlebars/4.7.6/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.6/js/handlebars";
import spartaTransportUtility from "utilities/global/sparta-transport-utility/4.0.2/js/sparta-transport-utility";
import spartaBootstrapUtility from "utilities/global/sparta-bootstrap-utility/4.2.3/js/sparta-bootstrap-utility";
import spartaMessageUtility from "utilities/global/sparta-messaging-utility/2.1.5/js/sparta-messaging-utility";
import spartaRequireUtility from "utilities/global/sparta-require-utility/2.1.3/js/sparta-require-utility";
import spartaExperienceUtility from "utilities/global/sparta-experience-utility/2.4.2/js/sparta-experience-utility";
import moduleContainer from "utilities/helpers/module-container/3.2.1/js/module-container";
import * as jcrUtility from "utilities/global/jcr-utility/1.0.2/js/jcr-utility";
import Communicator from "utilities/global/sparta-module-utility/6.2.5/js/communicator";
export default class View extends Communicator {
  constructor( options ) {
    super( options.settings );

    let defaults = {};

    this.settings = defaults;
    this.settings = $.extend(defaults, options.settings);

    this.model = options.model;

    this._initialize();
  }

  _initialize() {

  }

}